import React, {FC, useEffect, useState} from "react";
import NcdcRequestInfo from "./NcdcRequestInfo";
import NcdcRequestForm from "./NcdcRequestForm";
import NcdcRequestPeriod from "./NcdcRequestPeriod";
import NcdcRequestWork from "./NcdcRequestWork";
import NcdcRequestUser from "./NcdcRequestUser";
import NcdcRequestData from "./NcdcRequestData";
import NcdcRequestComplete from "./NcdcRequestComplete";

const NcdcRequest: FC = () => {
    const [page, setPage] = useState(0);
    const [insertData, setInsertData] = React.useState({});

    useEffect(() => {
        console.log('insertData!!', insertData)

    }, [insertData, page]);

    const getPage = (page: number) => {
        setPage(page);
        console.log('page!!', page)
    }

    const getData = (data: any) => {
        setInsertData(data);
        console.log('---')
        console.log('data!!', data)
        setInsertData({...insertData, ...data})
    }

    return (
        <div className={'ncdc-request-wrapper'}>
            <NcdcRequestInfo page={page} getPage={getPage} />
            <NcdcRequestForm page={page} getPage={getPage} getData={getData} />
            <NcdcRequestPeriod page={page} getPage={getPage} getData={getData} />
            <NcdcRequestWork page={page} getPage={getPage} getData={getData}/>
            <NcdcRequestUser page={page} getPage={getPage} getData={getData}/>
            <NcdcRequestData page={page} getPage={getPage} />
            <NcdcRequestComplete page={page} getPage={getPage} />
        </div>
    );
}

export default NcdcRequest;
